import { ValidationError } from './validation.error';

export type Status = 'NOT_STARTED' | 'IN_PROGRESS' | 'PENDING_VERIFICATION' | 'COMPLETE' | 'FAILED';

export const Statuses = {
  NOT_STARTED: 'NOT_STARTED' as Status,
  IN_PROGRESS: 'IN_PROGRESS' as Status,
  PENDING_VERIFICATION: 'PENDING_VERIFICATION' as Status,
  COMPLETE: 'COMPLETE' as Status,
  FAILED: 'FAILED' as Status,

  all(): Status[] {
    return Object.getOwnPropertyNames(this)
      .map(key => this[key])
      .filter(prop => typeof prop === 'string');
  },

  parse(status: Status | string | undefined): Status | undefined {
    if (!status) {
      return undefined;
    }

    if (!this.all().some(item => item === status)) {
      throw new ValidationError(`Invalid status "${status}"`);
    }

    return this[status];
  }
};



// WEBPACK FOOTER //
// ./src/gs-core/common/models/status.ts